import useIsMobile from '@/helpers/commonHooks/useIsMobile'
import TermsOfServicePagePc from './components/TermsOfServicePagePc/TermsOfServicePagePc'
import TermsOfServicePageMobile from './components/TermsOfServicePageMobile/TermsOfServicePageMobile'

function TermsOfServicePage() {
  const isMobile = useIsMobile()
  return isMobile ? <TermsOfServicePageMobile /> : <TermsOfServicePagePc />
}

export default TermsOfServicePage
